import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import UpsellCarousel from '~/shared/components/UpsellCarousel';
import { getDefaultProductFilters } from '~/shared/utils/getDefaultProductFilters';
import { getMembership } from '~/techstyle-shared/react-accounts';
import { useProductDetailSelectionState } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';
import { useProductListing } from '~/techstyle-shared/react-products';

import { CarouselHeading, CarouselSection } from './shared';

const prefix = config.get('public.brand.psourcePrefix');

function BestSellers({ fplCodes }) {
  const baseParams = {
    fplCodes,
    size: 15,
    includeOutOfStock: true,
  };
  const params = useSelector((state) =>
    getDefaultProductFilters(getMembership(state), state.domain.tld, baseParams)
  );
  const { products = [] } = useProductListing(params, { apiVersion: 2 });
  const { isPlusSizeSelected } = useProductDetailSelectionState();

  if (!products.length) {
    return null;
  }

  return (
    <CarouselSection>
      <CarouselHeading>
        <FormattedMessage
          id="site_pdp.related_best_sellers_heading"
          defaultMessage="Best Sellers"
        />
      </CarouselHeading>
      <UpsellCarousel
        products={products}
        isPlusSizeSelected={isPlusSizeSelected}
        psrc={`${prefix}top_sellers`}
        fplIds={fplCodes}
      />
    </CarouselSection>
  );
}

BestSellers.propTypes = {
  fplCodes: PropTypes.arrayOf(PropTypes.string),
};

export default BestSellers;
